import React from "react";
import PropTypes from "prop-types";
import Select2 from "@layout/Select2";

const AbstractInstitutes = (props) => {
  const [state, setState] = React.useState({ authors: [] });

  const getAuthors = () => {
    const authors = JSON.parse(JSON.stringify(props.authors));

    const lastAuthor = authors[authors.length - 1] || {};
    if (
      (lastAuthor.firstName != "" ||
        lastAuthor.lastName != "" ||
        lastAuthor.email != "" ||
        lastAuthor.institutes.length) &&
      !props.disabled
    )
      authors.push({
        firstName: "",
        lastName: "",
        email: "",
        institutes: [],
      });

    return authors;
  };

  React.useEffect(() => {
    const authors = getAuthors();
    setState({ authors });
  }, [props]);

  const onChangeAuthor = (prop, value, i) => {
    const newAuthors = [...state.authors];
    newAuthors[i][prop] = value;
    return props.onChange(newAuthors);
  };
  const removeAuthor = (i) => {
    const newAuthors = [...state.authors];
    newAuthors.splice(i, 1);
    return props.onChange(newAuthors);
  };
  const onChangeInstitute = (value, i) => {
    const newAuthors = [...state.authors];
    newAuthors[i].institutes = value;
    return props.onChange(newAuthors);
  };
  return (
    <div className="authors-container">
      <div className="row author-header">
        <div className="col-sm-3 col-xs-12 ">
          <label>First Name</label>
        </div>
        <div className="col-sm-3 col-xs-12 form-group">
          <label>Last Name</label>
        </div>
        <div className="col-sm-3 col-xs-12 form-group">
          <label>Email</label>
        </div>
        <div className="col-sm-3 col-xs-12 form-group">
          <label>Institute</label>
        </div>
      </div>
      {state.authors.map((author, index) => (
        <div key={`author-${index}`} className="row author-item ">
          <div className="col-sm-3 col-xs-12 ">
            <input
              disabled={props.disabled}
              className="form-control"
              value={author.firstName}
              placeholder="First Name"
              onChange={(e) =>
                onChangeAuthor("firstName", e.target.value, index)
              }
            />
          </div>
          <div className="col-sm-3 col-xs-12 form-group">
            <input
              disabled={props.disabled}
              className="form-control"
              value={author.lastName}
              placeholder="Last Name"
              onChange={(e) =>
                onChangeAuthor("lastName", e.target.value, index)
              }
            />
          </div>
          <div className="col-sm-3 col-xs-12 form-group">
            <input
              disabled={props.disabled}
              className="form-control"
              value={author.email}
              placeholder="Email"
              onChange={(e) => onChangeAuthor("email", e.target.value, index)}
            />
          </div>
          <div className="col-sm-3 col-xs-12 form-group author-institute-select">
            <Select2
              className={props.disabled ? "" : "select-institute"}
              minHeight={34}
              disabled={props.disabled}
              options={props.abstract.institutes.reduce(
                (prev, next) => ({ ...prev, [next.index]: next.name }),
                {}
              )}
              onChange={(val) => {
                onChangeInstitute(val, index);
              }}
              placeholder={"Select one or more institute"}
              value={author.institutes}
              multi={true}
              isSearchable={false}
              isClearable={false}
            />
            {!props.disabled && index != state.authors.length - 1 && (
              <div className="remove-item">
                <span
                  onClick={() => removeAuthor(index)}
                  className="fa fa-times-circle"
                ></span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

AbstractInstitutes.defaultProps = {
  authors: [],
};
AbstractInstitutes.propTypes = {
  authors: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  abstract: PropTypes.object.isRequired,
};

export default AbstractInstitutes;
